// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2153":"72b143ca","4744":"26677869","5899":"15e78a63"}[chunkId] + ".css";
};